
  module.exports =
  {

    backhaul:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    backhaulList:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#developments', 'Delay', 'backhaulList')

        this.onChangeABLD()

      },

      onChangeABLD: function ()
      {

        $('.js-abld').not('.js-ignore').change(function ()
        {

          var coins_development_id = $('.js-coins_development_id', $(this).closest('tr')).val()
          
          $.post(APPLICATION._PATH_PREFIX + 'delay/update-abld/' + coins_development_id,
          {
            abld: $(this).val()
          }
          , function (response)
          {
            console.log(response)
          }
          )

        }
        ).addClass('js-ignore')

      }

    },

    updateRd:
    {

      _init: function ()
      {

        this.onClickRD()

      },

      onClickRD: function()
      {

        $('#rd-calendar').not('.js-ignore').click(function ()
        {
  
          var form = $(this).closest('form').serialize()

          var plot_issue_id = $('#modal-plot_issue_id').val()
  
          APPLICATION._datepicker = function (date)
          {
  
            form += '&rd=' + date
  
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'delay/update-rd/' + plot_issue_id + '?' + form, 'Delay', 'updateRd')
  
          }
  
          var parts = $('#modal-rd').val().split('/')
  
          $('#calendar').data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&future=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0]).trigger('click')
  
        }
        ).addClass('js-ignore')

      }

    },

    plot:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    plotList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#plots', 'Delay', 'plotList')
      }

    }

  }